<script>
import { BSpinner } from 'bootstrap-vue'
export default {
  name: "AppLoader",

  components: {
    BSpinner
  },

  props: {
    opaque: { type: Boolean, default: false }
  }
}
</script>

<template>
  <div
    class="app-loader d-flex justify-content-center align-items-center"
    :class="{
      'bg-white': opaque
    }"
  >
    <b-spinner
      variant="primary"
      label="Loading..."
    ></b-spinner>
  </div>
</template>

<style lang="scss">
.app-loader {
  position: absolute;
  z-index: 5;
  background: rgba(255,255,255, 0.5);
  pointer-events: none !important;
  cursor: wait !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>